import { Card as MuiCard, CardProps as MuiCardProps, styled } from "@mui/material";

const StyledCard = styled(MuiCard)(({ theme }) => {
  return {
    backgroundColor: theme.palette.background.paper,
    padding: "2rem",
    margin: "1.5rem",
    boxShadow: "0px 0px 18px 0px rgba(0,0,0,0.15)",
    borderRadius: "0.5rem",
  };
});

interface CardProps extends MuiCardProps {
  children: React.ReactNode;
}

export const Card: React.FC<CardProps> = ({ children, ...props }) => {
  return <StyledCard {...props}>{children}</StyledCard>;
};

export default Card;
